@let detailsUnavailable = !order() || loading();
@let targetCurrency = orderDetails()?.currency;

@if (isDesktop()) {
  <div class="tabs">
    <iw-button
      size="m"
      fullWidth
      class="action"
      (click)="changeTab(TAB.DESCRIPTION)"
      [uiType]="isActiveTab(TAB.DESCRIPTION) ? 'primary' : 'quinary'"
    >
      {{ "ordersHistory.details.tab.orderDescription" | translate }}
    </iw-button>
    <iw-button
      size="m"
      fullWidth
      class="action"
      (click)="changeTab(TAB.MESSAGES)"
      [uiType]="isActiveTab(TAB.MESSAGES) ? 'primary' : 'quinary'"
    >
      {{ "ordersHistory.details.tab.messages" | translate }}
    </iw-button>
  </div>
} @else {
  <div class="header">
    <h4 class="header-text">{{ "ordersHistory.details.title" | translate }}</h4>
    <iw-button
      size="s"
      uiType="custom"
      [onlyIcon]="true"
      class="header-chat-btn"
      (click)="openMessages()"
    >
      <fu-icon iconName="chats" size="16" />
    </iw-button>
  </div>
}

@switch (tab()) {
  @case (TAB.DESCRIPTION) {
    @if (!isDesktop()) {
      <div class="hero">
        @if (detailsUnavailable) {
          <iw-shimmer count="1" height="38" width="180" />
          <iw-shimmer count="1" height="16" width="150" />
        } @else {
          <h5 class="hero-amount">
            <span>{{ targetCurrency?.symbol }}</span>
            <span>
              {{
                orderDetails()?.amount | decimal: targetCurrency.decimals
              }}</span
            >
          </h5>
          <p class="hero-subtitle">
            <span class="hero-subtitle-text">{{
              "ordersHistory.details.hero.fromWallet" | translate
            }}</span>
            <span class="hero-subtitle-value">
              {{
                "account.name"
                  | translate: { currency: currency().symbol || "" }
              }}</span
            >
          </p>
        }
      </div>
    }
    <iw-order-status
      [currency]="currency()"
      class="section status-section"
      [status]="orderOperation()?.status"
    />

    <section class="details">
      @if (!isDesktop()) {
        <h5 class="details-title">
          {{ "ordersHistory.details.details" | translate }}
        </h5>
      }
      @if (detailsUnavailable) {
        <iw-shimmer count="6" height="28" gap="16" />
      } @else {
        <iw-details-value
          class="row"
          [value]="orderDetails().id"
          label="ordersHistory.details.orderId"
        />
        <div class="row">
          <div>
            {{ "ordersHistory.details.creationDate" | translate }}
          </div>
          <div>
            {{ orderDetails().createdAt | date: "dd.MM.yyyy" }}
            &nbsp;
            <span class="date-time">{{
              orderDetails().createdAt | date: "HH:mm:ss"
            }}</span>
          </div>
        </div>
        <div class="row">
          <div>
            {{ "ordersHistory.details.changedDate" | translate }}
          </div>
          <div>
            {{ orderDetails().updatedAt | date: "dd.MM.yyyy" }}
            &nbsp;
            <span class="date-time">{{
              orderDetails().updatedAt | date: "HH:mm:ss"
            }}</span>
          </div>
        </div>
        <iw-details-value
          class="row"
          [value]="orderDetails().method"
          label="ordersHistory.details.method"
        />
        <iw-details-value
          class="row"
          label="ordersHistory.details.fromWallet"
          [value]="'account.name' | translate: { currency: currency().symbol }"
        />

        @let orderCurrencySymbol = targetCurrency?.symbol.toLocaleLowerCase();
        @let operationCurrencySymbol = currency()?.symbol.toLocaleLowerCase();

        @if (hasExchange()) {
          <iw-details-value
            class="row"
            [value]="orderOperation()?.amount"
            label="ordersHistory.details.amountToSend"
            [iconName]="operationCurrencySymbol"
          />
          <iw-details-value
            class="row"
            [value]="orderDetails()?.amount | decimal: targetCurrency.decimals"
            label="ordersHistory.details.amountToReceive"
            [iconName]="orderCurrencySymbol"
          />
          <iw-details-value
            class="row"
            [value]="orderOperation()?.details?.rate | decimal: '1.2-8'"
            label="ordersHistory.details.exchangeRate"
          />
        } @else {
          <iw-details-value
            class="row"
            [value]="orderDetails()?.amount | decimal: targetCurrency.decimals"
            label="ordersHistory.details.amount"
            [iconName]="orderCurrencySymbol"
          />
        }
        <iw-details-value
          class="row"
          label="ordersHistory.details.fee"
          [value]="orderOperation()?.commission | decimal: currency()?.decimals"
          [iconName]="operationCurrencySymbol"
        />
      }
    </section>
    @if (orderOperation()?.status === OperationStatus.Created) {
      <div class="actions">
        <iw-button
          size="m"
          fullWidth
          uiType="secondary"
          class="cancel-action"
          (click)="openCancelConfirm()"
        >
          {{ "ordersHistory.details.cancelOrder" | translate }}
        </iw-button>
      </div>
    }
  }
  @case (TAB.MESSAGES) {
    <iw-order-messages />
  }
}

@if (isDesktop()) {
  <div class="support-note">
    <fu-icon iconName="information-circle" size="16" />
    <div class="text">
      {{ "ordersHistory.details.support.text" | translate }}
      <a
        class="link"
        target="_blank"
        rel="noopener noreferrer"
        [href]="supportLink"
      >
        {{ "ordersHistory.details.support.link" | translate }}
      </a>
    </div>
  </div>
}
